/**
 *
 * @filename src/components/HTMLRender/constant.ts
 * @author  tujiawei <jiaweitu@marchthepolo.com>
 * @date 2024-11-08 14:02:21
 */

export const style = `
<style>

pre {
	white-space: pre-wrap !important;
}

p {
	margin-top: 0;
	margin-bottom: 1em;
}

blockquote {
  margin: 0 1em 1em;
}

</style>
`
